import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { CheckCircle, SpinnerGap, Database } from '@phosphor-icons/react';

export default function ConfigPage() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/config/status').then(r => { setConfig(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-20"><SpinnerGap size={28} className="animate-spin text-[#0F1829]" /></div>;

  return (
    <div data-testid="config-page" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <div className="mb-6">
        <h1 className="text-2xl font-bold tracking-tight text-[#111827]" style={{ fontFamily: "'Fraunces', sans-serif" }}>Configuração</h1>
        <p className="text-sm text-[#6B7280] mt-1">Estado da ligação ao SQL Server</p>
      </div>

      <div className="bg-white border border-[#E5E7EB] rounded-lg p-6 max-w-[500px]">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2 rounded-md bg-green-50">
            {config?.sqlserver?.connected ? <CheckCircle size={22} className="text-[#00C853]" weight="duotone" /> : <Database size={22} className="text-[#FF2B2B]" weight="duotone" />}
          </div>
          <div>
            <h3 className="text-sm font-semibold text-[#111827]">SQL Server</h3>
            <p className="text-xs text-[#6B7280]">Base de dados principal IHTP</p>
          </div>
        </div>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between"><span className="text-[#6B7280]">Ligação</span><span className={config?.sqlserver?.connected ? 'text-[#00C853] font-semibold' : 'text-[#FF2B2B]'}>{config?.sqlserver?.connected ? 'Ativa' : 'Inativa'}</span></div>
          <div className="flex justify-between"><span className="text-[#6B7280]">Base de Dados</span><span className="font-mono text-[#111827]">{config?.sqlserver?.database}</span></div>
          <div className="flex justify-between"><span className="text-[#6B7280]">Modo</span><span className="font-mono uppercase text-[#0F1829]">{config?.mode}</span></div>
        </div>
      </div>
    </div>
  );
}
